import React, { Component } from 'react'
import ContainerHeader from 'components/ContainerHeader/index'
import { editRecipePageTitle } from './formattedMessages/'
import EditRecipeContainer from './containers/'

class EditRecipePage extends Component {
  render() {
    return (
      <div className="app-wrapper">
        <ContainerHeader
          location={this.props.location}
          title={editRecipePageTitle}
        />
        <EditRecipeContainer />
      </div>
    )
  }
}

export default EditRecipePage
